import React, { useEffect, useState, useContext } from 'react'
import axios from "axios"
import { useTranslation } from "react-i18next"
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import '../pages.css'
import { MInputTextField, MButton, DefaultURl, LoadingContext, M_StateActions, MCheckBox } from 'src/M_Components'
import { MHeader } from 'src/M_Components/M_Header'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

export default function RoleConfigCrud({ toastMessages, handleTabClose }) {
    const dispatch = useDispatch()
    const M_State = useSelector(state => state.StateKeyValue)
    const passOperation = M_State.filter(obj => obj.key === 'operation')[0]?.value !== null ? M_State.filter(obj => obj.key === 'operation')[0]?.value : 'Error'
    const sessionLine = M_State.filter(obj => obj.key === 'rolesLine')[0]?.value !== null && M_State.filter(obj => obj.key === 'rolesLine')[0]?.value !== undefined ? M_State.filter(obj => obj.key === 'rolesLine')[0]?.value : 'Error'
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [roleName, setRoleName] = useState('')
    const [permissions, setPermissions] = useState([])
    const [operation, setOperation] = useState(passOperation)
    const [passLine, setPassLine] = useState('')
    const [isFirst, setIsFirst] = useState(true)
    const ctx = useContext(LoadingContext)
    const { t } = useTranslation()
    const columns = ["CanList", "CanCreate", "CanUpdate", "CanDelete", "CanRead", "IsAdmin"];

    const sessionKeys = ['operation', 'roleName', 'permissions', 'passLine', 'isFirst']

    //============================================================================================================
    // Helper function to get session keys
    //============================================================================================================
    function getSessionKeys() {
        return [
            operation, roleName, permissions, passLine, isFirst
        ]
    }

    //============================================================================================================
    // EFFECT
    // Mount: restore snapshot before any fetch and then consume/clear globals
    //============================================================================================================
    useEffect(() => {
        if (isFirst) {
            dispatch(M_StateActions.removeM_State({ key: 'rolesLine' }))
            dispatch(M_StateActions.removeM_State({ key: 'operation' }))
            setPassLine(sessionLine)
            setIsFirst(false)
        }
        getSessionStorageData(id)
        // eslint-disable-next-line
    }, [])

    //============================================================================================================
    // Helper function to manage session storage
    //============================================================================================================
    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (value instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(value)) }
        } else {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: value }
        }
        return tempObj
    }

    //============================================================================================================
    // Helper function to get session storage data
    //============================================================================================================
    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempO = M_StateData.filter(obj => obj?.key === `operation`)[0]?.value
            const tempRN = M_StateData.filter(obj => obj?.key === `roleName`)[0]?.value
            const tempP = M_StateData.filter(obj => obj?.key === `permissions`)[0]?.value
            const tempL = M_StateData.filter(obj => obj?.key === `passLine`)[0]?.value
            const tempIF = M_StateData.filter(obj => obj?.key === `isFirst`)[0]?.value
            if (tempO || tempRN || tempP || tempL || tempIF) {
                setOperation(tempO)
                setRoleName(tempRN ?? '')
                setPermissions(tempP)
                setPassLine(tempL)
                setIsFirst(tempIF)
                ctx.setIsLoad(false)
                return
            }
        }
        getRefresh(sessionLine)
    }

    //============================================================================================================
    // EFFECT
    // Checks if the selected tab has changed and gets session storage data
    //============================================================================================================
    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    //============================================================================================================
    // EFFECT
    //============================================================================================================
    useEffect(() => {
        const tempArray = []
        sessionKeys.forEach((key, index) => {
            tempArray.push(sessionStorageMachine(id, key, getSessionKeys()[index]))
        })
        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
        // eslint-disable-next-line
    }, [id, operation, roleName, permissions, passLine])

    function getRefresh(line) {
        const lineRole = line || passLine

        if (lineRole === 'Error' && operation !== 'Create') {
            handleTabClose(id)
            toastMessages('error', '', t("SelectedLine"))
            return
        }
        setRoleName(lineRole.Name)

        axios.get(`${DefaultURl}profiles/${lineRole.Id || 0}/grid`).then(response => {
            const profileData = response.data
            setPermissions(profileData.Permissions || [])
            ctx.setIsLoad(false)
        }).catch(error => {
            handleTabClose(id)
            toastMessages('error', '', error.message)
        })
    }

    //============================================================================================================
    // Helper function to render checkbox body
    //============================================================================================================
    const checkboxBody = (e, items) => {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <MCheckBox
                    checked={e[items] || false}
                    onChange={(elem) => changeTable(e.ModuleName, items, elem.target.checked)}
                    sx={{
                        padding: 0, color: ctx.primaryColor,
                        '&.Mui-checked': {
                            color: ctx.primaryColor,
                        },
                    }}
                />
            </div>
        )
    }

    //============================================================================================================
    // Helper function to change table data
    //============================================================================================================
    const changeTable = (name, field, value) => {
        setPermissions(permissions.map(obj => {
            if (obj.ModuleName === name) {
                return {
                    ...obj,
                    [field]: value
                }
            } else return obj;
        }));
    }


    //============================================================================================================
    // Function to save role changes in the api
    //============================================================================================================
    const onSave = () => {
        ctx.setIsLoad(true)
        const tempObj = {
            id: passLine.Id || 0,
            name: roleName,
            permissions
        }


        if (operation === 'Create' || operation === 'Copy') {

            axios.post(`${DefaultURl}Profiles/Create/Grid`, tempObj).then(response => {
                ctx.setIsLoad(false)
                toastMessages('success', '', t('Success'))
                setTimeout(() => {
                    handleTabClose(id)
                }, 1000);
            }).catch(error => {
                toastMessages('error', '', error.message)
            })
        } else {
            axios.put(`${DefaultURl}Profiles/Update/Grid`, tempObj).then(response => {
                ctx.setIsLoad(false)
                toastMessages('success', '', t('Success'))
                setTimeout(() => {
                    handleTabClose(id)
                }, 1000);
            }).catch(error => {
                toastMessages('error', '', error.message)
            })
        }
    }

    return (
        <div className='firstDivContainer'>
            <MHeader
                element={<>
                    <MButton
                        tooltip={t("RefreshTable")}
                        icon={<i className="pi pi-refresh headerIcon"></i>}
                        label={t("RefreshTable")}
                        onClick={() => getRefresh()}
                    />
                    <MButton
                        tooltip={t("Save")}
                        icon={<i className="pi pi-save headerIcon"></i>}
                        label={t("Save")}
                        onClick={() => onSave()}
                    />
                </>}
            />
            <div style={{
                marginBottom: '20px',
                padding: '20px',
                border: '2px solid var(--color-red-dark)',
                borderRadius: '8px',
            }}>
                <div className='tableDiv'>
                    <div style={{ width: '250px' }}>
                        <MInputTextField
                            disabled={operation === 'View'}
                            label={t("LabelRoleName")}
                            value={roleName}
                            onChange={(e) => setRoleName(e.target.value)}
                        />
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '15px'
                }}
                >
                    <DataTable value={permissions} dataKey="ModuleId" tableStyle={{ minWidth: '70rem' }}>

                        <Column field="ModuleName" header={t("Modules")} />

                        {columns.map((items, index) => (
                            <Column
                                key={items}
                                field={items}
                                header={t(items)}
                                body={(e) => checkboxBody(e, items)}
                                style={{ textAlign: 'center' }}
                            />
                        ))}
                    </DataTable>

                </div>
            </div>
        </div >
    )
}

RoleConfigCrud.propTypes = {
    toastMessages: PropTypes.func,
    handleTabClose: PropTypes.func
}